import { useEffect, useMemo, useState } from 'react';
import { theme } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate, useParams } from 'react-router-dom';
import AuthService from 'services/auth';
import StoreSettingService from 'services/store_setting';
import { useAuth } from 'contexts/auth';
import { useApp } from 'contexts/app';

const authService = new AuthService();
const storeSettingService = new StoreSettingService();

const useShopLogin = () => {
  const { token } = theme.useToken();
  const [form] = useForm();

  const { showLoading } = useApp();
  const [loginError, setLoginError] = useState(null);
  const [shopInfo, setShopInfo] = useState({
    title: 'Welcome back!',
    logo: 'https://storage.googleapis.com/cubebio/default/siprologo.png',
  });
  const navigate = useNavigate();
  const { login } = useAuth();
  const { shop_code } = useParams();

  const shopID = useMemo(() => String(shop_code || '').trim().toLowerCase(), [shop_code]);

  useEffect(() => {
    localStorage.removeItem('workSpace');
  }, []);

  useEffect(() => {
    const loadShopInfo = async () => {
      if (!shopID) {
        return;
      }

      try {
        const setting = await storeSettingService.getPublicStoreSetting({ shopCode: shopID });
        const webSetting = setting?.web || {};
        setShopInfo({
          title: webSetting?.title || 'Welcome back!',
          logo: webSetting?.image?.md_url || 'https://storage.googleapis.com/cubebio/default/siprologo.png',
        });
      } catch (error) {
      }
    };

    loadShopInfo();
  }, [shopID]);

  const handleContinue = () => {
    form.submit();
  };

  const onFinish = async () => {
    setLoginError(null);
    showLoading(true);
    const values = { ...form.getFieldsValue() };

    const data = {
      user_name: String(values.user_name || '').trim().toLowerCase(),
      w_id: shopID,
      pass: values.pass,
    };

    const user = await authService.userLogin(data);
    showLoading(false);
    if (user) {
      login(user);
    } else {
      setLoginError({ message: 'Incorrect username or password' });
    }
  };

  return {
    token,
    form,
    loginError,
    shopInfo,
    navigate,
    handleContinue,
    onFinish,
  };
};

export default useShopLogin;
